import type { JSX } from 'react';
import React from 'react';

import CampaignSpendCard from './CampaignSpendCard';
import ConversionRatesCard from './ConversionRatesCard';

function GrowthCreditsQA(): JSX.Element {
  return (
    <>
      <ConversionRatesCard />
      <CampaignSpendCard />
    </>
  );
}

export default GrowthCreditsQA;
